export const CONTACT_DEFAULTS = {
  email: "omr.perfumer@gmail.com",
  whatsapp_number: "971562999957",
  phone: "+971 56 299 9957",
  instagram_url: "https://instagram.com/omr.perfumer",
};

export const contactFrom = (s = {}) => ({
  email: s.email || CONTACT_DEFAULTS.email,
  whatsapp: (s.whatsapp_number || CONTACT_DEFAULTS.whatsapp_number).replace(/[^0-9]/g, ""),
  phone: s.phone || CONTACT_DEFAULTS.phone,
  instagram: s.instagram_url || CONTACT_DEFAULTS.instagram_url,
});
